export enum AccountSource {
  MANUAL = 0,
  ACTIVEDIR = 1,
  VIFOR = 2,
  SSO_SAML = 4,
  NEXUS = 5,
}

export type AccountSourceId = AccountSource.MANUAL | AccountSource.ACTIVEDIR | AccountSource.VIFOR | AccountSource.SSO_SAML | AccountSource.NEXUS;
